import { versionToJson } from '../../machineapp_utils';


export function MachineParameters(pLibrary, pType, pUuid, pName, pVersion, pData, pVid) {
  this.mLibrary = pLibrary;
  this.mType = pType;
  this.mUuid = pUuid;
  this.mName = pName;
  this.mVersion = pVersion;
  this.mData = pData;

  this.mVid = pVid; // Cad-Only
}

MachineParameters.prototype.getLibrary = function () { return this.mLibrary; };
MachineParameters.prototype.setDirty = function (pOnSuccess, pOnError) { this.getLibrary().upsert(this.getItemType(), this, pOnSuccess, pOnError, { saveImmediate: true }); };
MachineParameters.prototype.getType = function () { return this.mType; };
MachineParameters.prototype.getUuid = function () { return this.mUuid; };
MachineParameters.prototype.getVid = function () { return this.mVid; }; // Cad-Only
MachineParameters.prototype.getName = function () { return this.mName; };
MachineParameters.prototype.setName = function (pName, pCallback) { this.mName = pName; this.setDirty(pCallback); };
MachineParameters.prototype.getData = function () { return this.mData; };
MachineParameters.prototype.setData = function (pData, pCallback) { this.mData = pData; this.setDirty(pCallback); };
MachineParameters.prototype.getItemType = function () { return 'calibration'; };
MachineParameters.prototype.toJson = function () {
  return {
    type: this.getType(),
    uuid: this.getUuid(),
    name: this.getName(),
    version: versionToJson(this.mVersion),
    calibration: this.getData(),
    itemType: this.getItemType()
  };
};
